export const mapData =   [
    [
    116.48918862,
    40.1186032
],
[
    116.49006747,
    40.11733076
],
[
    116.49043375,
    40.11679856
],
[
    116.49152962,
    40.1140205
],
[
    116.4922236,
    40.11149056
],
[
    116.49241492,
    40.10914254
],
[
    116.49233439,
    40.10787022
],
[
    116.49078876,
    40.10778003
],
[
    116.4904052,
    40.10375282
],
[
    116.49011218,
    40.10270501
],
[
    116.48964335,
    40.101999
],
[
    116.48841146,
    40.10105964
],
[
    116.48704676,
    40.10005136
],
[
    116.48586686,
    40.09926789
],
[
    116.48512945,
    40.09900184
],
[
    116.48379677,
    40.09851641
],
[
    116.48263236,
    40.09762851
],
[
    116.48088379,
    40.09698202
],
[
    116.47945463,
    40.09765023
],
[
    116.4776559,
    40.09797574
],
[
    116.47626628,
    40.09756387
],
[
    116.47487496,
    40.09671316
],
[
    116.47433345,
    40.09681384
],
[
    116.4737957,
    40.0974352
],
[
    116.47334443,
    40.09750711
],
[
    116.47311504,
    40.0972626
],
[
    116.47267881,
    40.09681097
],
[
    116.47187406,
    40.09646577
],
[
    116.4700583,
    40.09566214
],
[
    116.46635313,
    40.09483907
],
[
    116.46491692,
    40.09352817
],
[
    116.46475564,
    40.09283767
],
[
    116.46500699,
    40.09239559
],
[
    116.46601282,
    40.09156438
],
[
    116.46684191,
    40.0901854
],
[
    116.46994207,
    40.08987671
],
[
    116.47101232,
    40.08939485
],
[
    116.47161926,
    40.08788924
],
[
    116.47164562,
    40.08787093
],
[
    116.47356045,
    40.08554998
],
[
    116.47507761,
    40.08496255
],
[
    116.47511611,
    40.08495901
],
[
    116.47979227,
    40.08451487
],
[
    116.48294201,
    40.08374604
],
[
    116.48339001,
    40.08324048
],
[
    116.48294141,
    40.08238027
],
[
    116.4840223,
    40.08250923
],
[
    116.48513727,
    40.08232584
],
[
    116.48570354,
    40.08199841
],
[
    116.48667474,
    40.081037
],
[
    116.48673009,
    40.08102462
],
[
    116.49211124,
    40.0806572
],
[
    116.49451132,
    40.08050098
],
[
    116.49829487,
    40.0803022
],
[
    116.4993482,
    40.08040397
],
[
    116.50113993,
    40.0793678
],
[
    116.50381929,
    40.0776123
],
[
    116.50540286,
    40.07610761
],
[
    116.50678731,
    40.07435023
],
[
    116.50842996,
    40.07307093
],
[
    116.51140612,
    40.0710826
],
[
    116.5126944,
    40.07065724
],
[
    116.51394129,
    40.07042266
],
[
    116.51494108,
    40.07045981
],
[
    116.51804356,
    40.0710753
],
[
    116.52019806,
    40.07130552
],
[
    116.52308665,
    40.07144691
],
[
    116.52599143,
    40.07133435
],
[
    116.52823245,
    40.07082529
],
[
    116.52942169,
    40.07029081
],
[
    116.53296103,
    40.0679824
],
[
    116.5344,
    40.06678311
],
[
    116.53640966,
    40.06472197
],
[
    116.53778148,
    40.06312168
],
[
    116.53873914,
    40.06224801
],
[
    116.54002185,
    40.06140629
],
[
    116.54216915,
    40.05999271
],
[
    116.54318057,
    40.05940615
],
[
    116.54530596,
    40.06094221
],
[
    116.54621362,
    40.06359223
],
[
    116.54028175,
    40.06915767
],
[
    116.54077491,
    40.06995149
],
[
    116.54030443,
    40.07018139
],
[
    116.5418953,
    40.07244856
],
[
    116.53869221,
    40.07957619
],
[
    116.54030008,
    40.07961945
],
[
    116.54342162,
    40.07962906
],
[
    116.54490276,
    40.08045441
],
[
    116.54451203,
    40.08256523
],
[
    116.54542039,
    40.08258117
],
[
    116.54853747,
    40.08340102
],
[
    116.55177751,
    40.08526958
],
[
    116.553215,
    40.08556713
],
[
    116.55379789,
    40.0848277
],
[
    116.55470041,
    40.08476441
],
[
    116.55579955,
    40.0859024
],
[
    116.55600658,
    40.08591279
],
[
    116.5573928,
    40.0874244
],
[
    116.55667932,
    40.08774684
],
[
    116.55680652,
    40.08831729
],
[
    116.55644212,
    40.08858915
],
[
    116.55674296,
    40.08873148
],
[
    116.55670469,
    40.08887441
],
[
    116.55628785,
    40.09042313
],
[
    116.55660642,
    40.09045845
],
[
    116.55619394,
    40.09208506
],
[
    116.55440291,
    40.09229321
],
[
    116.55475993,
    40.0944964
],
[
    116.55753244,
    40.09429461
],
[
    116.55731634,
    40.09279562
],
[
    116.55922318,
    40.09264655
],
[
    116.55950849,
    40.09445132
],
[
    116.56338482,
    40.09413722
],
[
    116.56445909,
    40.09656241
],
[
    116.57432816,
    40.09614059
],
[
    116.57445853,
    40.09634439
],
[
    116.57444152,
    40.09670862
],
[
    116.57443018,
    40.09782731
],
[
    116.57440752,
    40.09948736
],
[
    116.57422082,
    40.10103955
],
[
    116.57404224,
    40.10218816
],
[
    116.57348254,
    40.10517904
],
[
    116.57446973,
    40.10530391
],
[
    116.57406145,
    40.107805
],
[
    116.57553248,
    40.10793532
],
[
    116.57591867,
    40.10542701
],
[
    116.57629628,
    40.10546131
],
[
    116.57652026,
    40.10430932
],
[
    116.57740265,
    40.10429225
],
[
    116.57771461,
    40.10330459
],
[
    116.57798581,
    40.10304739
],
[
    116.5816556,
    40.10337255
],
[
    116.58175767,
    40.10281717
],
[
    116.58454413,
    40.10301798
],
[
    116.5881097,
    40.10305589
],
[
    116.58793566,
    40.10387357
],
[
    116.58864549,
    40.10395583
],
[
    116.58802168,
    40.1094179
],
[
    116.5875079,
    40.11739051
],
[
    116.58639162,
    40.12768154
],
[
    116.58639794,
    40.13098068
],
[
    116.57632518,
    40.13087626
],
[
    116.57634949,
    40.12702218
],
[
    116.57619846,
    40.12706785
],
[
    116.57462386,
    40.12754407
],
[
    116.57465017,
    40.12731267
],
[
    116.57097789,
    40.12758269
],
[
    116.57098623,
    40.12768146
],
[
    116.56468139,
    40.12765793
],
[
    116.56269828,
    40.12745357
],
[
    116.5608243,
    40.12725593
],
[
    116.56086163,
    40.12325023
],
[
    116.55721518,
    40.12291632
],
[
    116.55736463,
    40.12055363
],
[
    116.55221446,
    40.12048952
],
[
    116.55211194,
    40.122136
],
[
    116.54353464,
    40.12136996
],
[
    116.54349288,
    40.12204067
],
[
    116.5417162,
    40.12192787
],
[
    116.54070501,
    40.12460775
],
[
    116.53594852,
    40.12328658
],
[
    116.53562351,
    40.12412136
],
[
    116.53548262,
    40.12409516
],
[
    116.53311172,
    40.12366184
],
[
    116.53265868,
    40.12569879
],
[
    116.53436487,
    40.12597185
],
[
    116.53409846,
    40.12678234
],
[
    116.53301579,
    40.12663065
],
[
    116.53291943,
    40.12680401
],
[
    116.5324943,
    40.12666099
],
[
    116.53255098,
    40.12650929
],
[
    116.5312926,
    40.12622323
],
[
    116.53040573,
    40.1285923
],
[
    116.52978913,
    40.13146164
],
[
    116.52542239,
    40.13072526
],
[
    116.52457031,
    40.13346785
],
[
    116.52394977,
    40.13344504
],
[
    116.52389607,
    40.13398334
],
[
    116.52328747,
    40.13410651
],
[
    116.52271466,
    40.13414756
],
[
    116.52258936,
    40.13452163
],
[
    116.52137811,
    40.13443952
],
[
    116.52122894,
    40.13435285
],
[
    116.52037569,
    40.13424792
],
[
    116.52033989,
    40.13407457
],
[
    116.51988641,
    40.13406089
],
[
    116.51988575,
    40.13382451
],
[
    116.51992325,
    40.13308542
],
[
    116.5114963,
    40.13251907
],
[
    116.51167346,
    40.13110398
],
[
    116.51250139,
    40.13094883
],
[
    116.51259067,
    40.12908078
],
[
    116.51186826,
    40.12845395
],
[
    116.51176419,
    40.12683166
],
[
    116.51095811,
    40.12661214
],
[
    116.5087055,
    40.1243409
],
[
    116.50989805,
    40.12404539
],
[
    116.50988666,
    40.12317448
],
[
    116.50890785,
    40.12230439
],
[
    116.50695023,
    40.12067645
],
[
    116.50728058,
    40.12048933
],
[
    116.50685235,
    40.1201338
],
[
    116.50619166,
    40.11956307
],
[
    116.50599136,
    40.11873448
],
[
    116.50499507,
    40.11860563
],
[
    116.50500971,
    40.11749643
],
[
    116.50298052,
    40.1174236
],
[
    116.5011125,
    40.1179614
],
[
    116.49906747,
    40.11838602
],
[
    116.49847372,
    40.11898749
],
[
    116.49763321,
    40.11990148
],
[
    116.4972785,
    40.11997814
],
[
    116.49593675,
    40.11996635
],
[
    116.49467355,
    40.11981772
],
[
    116.49387943,
    40.11969768
],
[
    116.49279907,
    40.11914691
],
[
    116.4922912,
    40.11841961
],
[
    116.49197725,
    40.11822542
],
[
    116.49176949,
    40.11837371
],
[
    116.49129394,
    40.11850434
],
[
    116.49015818,
    40.1186491
],
[
    116.48994118,
    40.11877267
],
[
    116.48918862,
    40.1186032
]
];
export const glyMapData = [
  [
    116.54297349,
    40.12145414
  ],
  [
    116.55177349,
    40.12204576
  ],
  [
    116.55191126,
    40.12002812
  ],
  [
    116.55741873,
    40.12036441
  ],
  [
    116.55719338,
    40.12304958
  ],
  [
    116.56084534,
    40.12306549
  ],
  [
    116.56045194,
    40.12676249
  ],
  [
    116.56987583,
    40.12695415
  ],
  [
    116.5698788,
    40.12655524
  ],
  [
    116.57565175,
    40.12675001
  ],
  [
    116.57622852,
    40.13092846
  ],
  [
    116.58634455,
    40.13105981
  ],
  [
    116.58790442,
    40.14365598
  ],
  [
    116.5898974,
    40.15055985
  ],
  [
    116.59061269,
    40.15499803
  ],
  [
    116.58842676,
    40.18623762
  ],
  [
    116.57887373,
    40.18595521
  ],
  [
    116.57781255,
    40.19513434
  ],
  [
    116.57451898,
    40.19486034
  ],
  [
    116.57524242,
    40.18586276
  ],
  [
    116.57432194,
    40.18583531
  ],
  [
    116.5740727,
    40.18222985
  ],
  [
    116.56152395,
    40.18202445
  ],
  [
    116.56107903,
    40.17979953
  ],
  [
    116.55245586,
    40.17971511
  ],
  [
    116.55275202,
    40.1819448
  ],
  [
    116.54948949,
    40.18178361
  ],
  [
    116.54929827,
    40.18146714
  ],
  [
    116.54804716,
    40.18129847
  ],
  [
    116.54199022,
    40.18135959
  ],
  [
    116.54181307,
    40.18311102
  ],
  [
    116.53965706,
    40.18319903
  ],
  [
    116.5407527,
    40.18506146
  ],
  [
    116.5351545,
    40.18533552
  ],
  [
    116.53529539,
    40.18654539
  ],
  [
    116.52997096,
    40.18682971
  ],
  [
    116.53035931,
    40.19300272
  ],
  [
    116.51557937,
    40.19432967
  ],
  [
    116.51372309,
    40.19490135
  ],
  [
    116.51268042,
    40.194005
  ],
  [
    116.50999395,
    40.19257322
  ],
  [
    116.50974503,
    40.19211072
  ],
  [
    116.51010299,
    40.19048654
  ],
  [
    116.50656475,
    40.19073264
  ],
  [
    116.50671692,
    40.1916954
  ],
  [
    116.50318685,
    40.19163753
  ],
  [
    116.50311484,
    40.19258848
  ],
  [
    116.50085757,
    40.19264177
  ],
  [
    116.5009193,
    40.19512518
  ],
  [
    116.49760303,
    40.19488985
  ],
  [
    116.49759353,
    40.19426407
  ],
  [
    116.49305198,
    40.19387824
  ],
  [
    116.49297359,
    40.1942602
  ],
  [
    116.4902534,
    40.19402476
  ],
  [
    116.48997372,
    40.19164316
  ],
  [
    116.48780954,
    40.19203499
  ],
  [
    116.48811731,
    40.19175952
  ],
  [
    116.48723018,
    40.18283198
  ],
  [
    116.4884709,
    40.18281137
  ],
  [
    116.48859848,
    40.17789245
  ],
  [
    116.48504957,
    40.17703827
  ],
  [
    116.48252021,
    40.16941444
  ],
  [
    116.4803002,
    40.16969431
  ],
  [
    116.48012309,
    40.16827653
  ],
  [
    116.47941536,
    40.16805247
  ],
  [
    116.47833623,
    40.16388758
  ],
  [
    116.48026806,
    40.16378775
  ],
  [
    116.48016756,
    40.1628609
  ],
  [
    116.47796715,
    40.16304527
  ],
  [
    116.47669513,
    40.15887198
  ],
  [
    116.47860529,
    40.15882977
  ],
  [
    116.47901267,
    40.15991768
  ],
  [
    116.48515321,
    40.15956913
  ],
  [
    116.48504439,
    40.15849064
  ],
  [
    116.48851967,
    40.15845525
  ],
  [
    116.48694355,
    40.15009631
  ],
  [
    116.48316273,
    40.15090087
  ],
  [
    116.48078759,
    40.14744579
  ],
  [
    116.47907801,
    40.1479752
  ],
  [
    116.47883587,
    40.14672992
  ],
  [
    116.4801547,
    40.14224467
  ],
  [
    116.48226128,
    40.14261387
  ],
  [
    116.48296946,
    40.14103426
  ],
  [
    116.4847647,
    40.14025522
  ],
  [
    116.48730315,
    40.12494433
  ],
  [
    116.48739694,
    40.12439047
  ],
  [
    116.48786386,
    40.12429954
  ],
  [
    116.48866009,
    40.12341938
  ],
  [
    116.48940346,
    40.12202812
  ],
  [
    116.48931869,
    40.11866915
  ],
  [
    116.49044718,
    40.11660067
  ],
  [
    116.49141458,
    40.11793721
  ],
  [
    116.49223292,
    40.11836682
  ],
  [
    116.49361558,
    40.11957606
  ],
  [
    116.495593,
    40.11985456
  ],
  [
    116.49843833,
    40.11738919
  ],
  [
    116.50540968,
    40.1176976
  ],
  [
    116.50869906,
    40.12106792
  ],
  [
    116.50818878,
    40.1212742
  ],
  [
    116.51024606,
    40.12572814
  ],
  [
    116.51210811,
    40.12707374
  ],
  [
    116.51197241,
    40.12912897
  ],
  [
    116.51280827,
    40.12942502
  ],
  [
    116.51264969,
    40.13106325
  ],
  [
    116.51194106,
    40.13127585
  ],
  [
    116.51191047,
    40.13253015
  ],
  [
    116.52026834,
    40.1332118
  ],
  [
    116.52009611,
    40.13414779
  ],
  [
    116.52268105,
    40.13463463
  ],
  [
    116.52267883,
    40.13414099
  ],
  [
    116.52404144,
    40.13407833
  ],
  [
    116.52407114,
    40.13326085
  ],
  [
    116.52541208,
    40.13325585
  ],
  [
    116.52579764,
    40.13077485
  ],
  [
    116.52986827,
    40.13163187
  ],
  [
    116.53179428,
    40.12644275
  ],
  [
    116.53447646,
    40.12734415
  ],
  [
    116.53500085,
    40.12603595
  ],
  [
    116.53327033,
    40.12573057
  ],
  [
    116.53376355,
    40.12385358
  ],
  [
    116.53662536,
    40.12440759
  ],
  [
    116.53611257,
    40.12320854
  ],
  [
    116.54291377,
    40.12449093
  ],
  [
    116.54294212,
    40.12274276
  ],
  [
    116.54297349,
    40.12145414
  ]
];
export const glylxhyMapData = [
            [
              116.55234715,
              40.15982553
            ],
            [
              116.55011552,
              40.15979733
            ],
            [
              116.55008786,
              40.15919124
            ],
            [
              116.5488245,
              40.15920533
            ],
            [
              116.54832653,
              40.15845123
            ],
            [
              116.54831731,
              40.15804246
            ],
            [
              116.55235637,
              40.15714034
            ],
            [
              116.55234715,
              40.15982553
            ]
          ];
export const glyxyzyMapData = [
            [
              116.49859725,
              40.13663488
            ],
            [
              116.49540773,
              40.13635366
            ],
            [
              116.49552437,
              40.13492694
            ],
            [
              116.49639913,
              40.13498867
            ],
            [
              116.4964081,
              40.13433361
            ],
            [
              116.49866454,
              40.13445021
            ],
            [
              116.49859725,
              40.13663488
            ]
          ];
export const glylxnyMapData =[
            [
              116.54999305,
              40.15735454
            ],
            [
              116.54825205,
              40.15773471
            ],
            [
              116.54822279,
              40.15484982
            ],
            [
              116.55003694,
              40.154492
            ],
            [
              116.54999305,
              40.15735454
            ]
          ];
export const glywwsMapData = [
  [
              116.55017407,
              40.15434957
            ],
            [
              116.54125326,
              40.15600133
            ],
            [
              116.53979083,
              40.15018893
            ],
            [
              116.54191947,
              40.14774211
            ],
            [
              116.54333315,
              40.14811473
            ],
            [
              116.5434469,
              40.15263566
            ],
            [
              116.55019032,
              40.15212645
            ],
            [
              116.55017407,
              40.15434957
            ]
          ];
          
export const glygcbsMapData = [
            [
              116.49883537,
              40.13421953
            ],
            [
              116.49557931,
              40.13410807
            ],
            [
              116.49553071,
              40.13117277
            ],
            [
              116.49486654,
              40.12751894
            ],
            [
              116.49251764,
              40.12733313
            ],
            [
              116.4935382,
              40.12418696
            ],
            [
              116.49710204,
              40.12447186
            ],
            [
              116.49854378,
              40.1277171
            ],
            [
              116.49867338,
              40.13127183
            ],
            [
              116.49883537,
              40.13421953
            ]
          ];

export const glygchysyMapData =  [
            [
              116.4910759,
              40.13378605
            ],
            [
              116.48673449,
              40.13337735
            ],
            [
              116.48689648,
              40.13128423
            ],
            [
              116.49096251,
              40.13120992
            ],
            [
              116.4910759,
              40.13378605
            ]
          ];

export const glyxsjlzMapData = [
            [
              116.49528772,
              40.13633732
            ],
            [
              116.48697748,
              40.13586671
            ],
            [
              116.48736626,
              40.13369936
            ],
            [
              116.49546591,
              40.13423191
            ],
            [
              116.49528772,
              40.13633732
            ]
          ];

export const glyxxyMapData = [
            [
              116.54803037,
              40.16361818
            ],
            [
              116.54613839,
              40.16388836
            ],
            [
              116.54516374,
              40.16201895
            ],
            [
              116.54522107,
              40.16069719
            ],
            [
              116.54811637,
              40.16065337
            ],
            [
              116.54803037,
              40.16361818
            ]
          ];

          
export const glyflskjxptMapData = [
            [
              116.4937264,
              40.16400519
            ],
            [
              116.49338047,
              40.1617003
            ],
            [
              116.49797478,
              40.16126244
            ],
            [
              116.498418,
              40.16369127
            ],
            [
              116.4937264,
              40.16400519
            ]
          ]

export const glyflskshgjMapData = [
            [
              116.49655866,
              40.16117982
            ],
            [
              116.49619111,
              40.15823042
            ],
            [
              116.49899094,
              40.15796604
            ],
            [
              116.49962874,
              40.15868481
            ],
            [
              116.49996385,
              40.1608411
            ],
            [
              116.49655866,
              40.16117982
            ]
          ]

export const glyschyMapData = [
            [
              116.55509654,
              40.15650951
            ],
            [
              116.55503696,
              40.15555322
            ],
            [
              116.553662,
              40.15563729
            ],
            [
              116.5536345,
              40.15432018
            ],
            [
              116.55618734,
              40.1543447
            ],
            [
              116.55630192,
              40.15647448
            ],
            [
              116.55509654,
              40.15650951
            ]
          ]